import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'app/shared/i18n';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="ms-footer">
      <div className="ms-footer__inner">
        <div className="ms-footer__brand">
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 8,
              background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 14,
              fontWeight: 800,
              color: '#000',
            }}
          >
            M
          </div>
          <span>&copy; 2025 Q8Tools. {t('footer.copyright')}</span>
        </div>
        <div className="ms-footer__links">
          <Link to="/terms-of-service">{t('footer.terms')}</Link>
          <Link to="/policy">{t('footer.privacy')}</Link>
          <a href="https://t.me/q8tools" target="_blank" rel="noreferrer">
            Telegram ↗
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
